import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { AdminOrderItemComponentResponse } from './admin-order-item-component.response';

@jsonObject
export class AdminOrderItemComponentGroupResponse {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Boolean)
  public readonly isRandomSelected!: boolean;

  @jsonArrayMember(AdminOrderItemComponentResponse)
  public readonly components!: AdminOrderItemComponentResponse[];
}
